/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ISelectOption {
        value: string;
        text: string;
    }

    /**
     * MobileDataController class
     */
    export class SimsController {
        public static $name: string = "simsController";
        public static $inject: string[] = [
            '$scope',
            'ModalService',
            'simService',
            'simPlanService',
            '$timeout',
            'messageTranslationsService',
        ];

        private static DEFAULT_DATA_PLAN: number = Math.pow(1024, 2);
        private static UNKNOWN_PLAN: string = "UNKNOWN";

        private simCards: Models.IPaginatedList<Models.ISIM>;
        private paginationSize: number;
        private paginationPage: number;

        private selectize: Selectize.IApi<number, ISelectOption>;
        private simPlans: Models.ISimPlan[];
        
        private totalSims: number;
        private noPlanSims: number;
        private lowDataRemainingSims: number;
        private medDataRemainingSims: number;
        private higDataRemainingSims: number;
        private topSimPlans: Models.ISIMTopPlan[];

        private unassignedPercentage: number;
        private lowremPercentage: number;
        private medremPercentage: number;
        private highremPercentage: number;

        /**
         * Constructor of the class.
         */
        constructor(private $scope: ng.IScope,
                    private modalService: ngModal.IModalService,
                    private simService: Services.SIMService,
                    private simPlanService: Services.SimPlanService,
                    private $timeout: ng.ITimeoutService,
                    private messageTranslationsService: Services.MessageTranslationsService ) {
            
            this.initData();
            this.selectize = undefined;
            this.loadSelectize();
            
            this.$scope.$on('$destroy', () => {
                if (this.selectize)
                    this.selectize.destroy();
            });
        }

        public saveSIM(result: IModalResult, sim: Models.ISIM): void {
            this.saveSIMCard(result.sim, sim, (savedSim: Models.ISIM) => {
                if (result.newRemainingData) {
                    this.setDataRemaining(savedSim, result.newRemainingData);
                    this.loadDashboardData();
                }
            });
        }

        public saveSIMCard(sim: Models.ISIM, copy: Models.ISIM, callback: (sim: Models.ISIM) => void): void {
            if (sim) {
                this.simService.existsSIMByIccid(sim.iccid)
                    .then((exists: boolean) => {
                        if (exists && copy && copy.iccid !== sim.iccid) {
                            // if iccid already exists and we're not updating an element
                            this.messageTranslationsService.alertOnError("Error - Iccid already exists");
                            $('#saving-spinner').css({display: 'none'});
                        } else {
                            this.simService.saveSIM(sim)
                                .then((savedSim: Models.ISIM) => {
                                    this.changePageNumber(this.simCards.page.totalPages - 1);
                                    $('#saving-spinner').css({display: 'none'});
                                    callback(savedSim);
                                })
                                .catch(() => {
                                    $('#saving-spinner').css({display: 'none'});
                                    this.messageTranslationsService.alertOnError("Something was wrong creating/updating the SIM");
                                });
                        }
                    });
            }
        }

        public setDataRemaining(sim: Models.ISIM, remainingData: number): void {
            let date: Date = new Date();
            this.simService
                .setRemainingData(sim.href, remainingData, date)
                .then((newValue: number) => {
                    this.changePageNumber(this.simCards.page.totalPages - 1);
                });
        }

        /**
         * Delete a given sim and move the view to the first page.
         * @param {Models.ISIM} sim - The sim to be deleted.
         */
        public deleteSIMCard(sim: Models.ISIM): void {
            this.simService
                .deleteSIM(sim)
                .then(() => {
                    this.changePageNumber(0);
                    this.loadDashboardData();
                    $('#saving-spinner').css({display: 'none'});
                }
            );
        }

        /**
         * Change the list view to another a given page.
         * @param {number} page - The page number to show
         */
        public changePageNumber(page: number): void {
            this.paginationPage = page;
            this.loadSimCards(this.paginationPage, this.paginationSize, undefined);
        }

        public launchDataModal(title: string, element: Models.ISIM): void {
            this.simService
                .getRemainingData(Common.Utils.idFromHref(element.href))
                .then((remaining: number) => {
                    this.modalService
                        .showModal({
                            templateUrl: Application.Controllers.SIMDataModalController.templateURL,
                            controller: Application.Controllers.SIMDataModalController.$name,
                            inputs: {
                                title: title,
                                sim: element,
                                currentRemaining: remaining,
                            },
                        })
                        .then((modal: ngModal.IModalObject) => {
                            let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.SIMDataModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                            modalElem.show();
                            modal.scope.loadSelectize();
                            modal.close.then((result: Object[]) => {
                                modalElem.hide();
                                if (result) {
                                    let dataAmount: number = result[0] as number;
                                    let operation: string = result[1] as string;
                                    let date: Date = result[2] as Date;
                                    if (operation === 'SET') {
                                        this.simService
                                            .setRemainingData(element.href, dataAmount, date)
                                            .then((newValue: number) => {
                                                this.changePageNumber(this.simCards.page.totalPages - 1);
                                            });
                                    } else if (operation === 'ADD') {
                                        this.simService
                                            .addData(element.href, dataAmount, date)
                                            .then((newValue: number) => {
                                                this.changePageNumber(this.simCards.page.totalPages - 1);
                                            });
                                    }
                                    this.loadDashboardData();
                                }
                            });
                        });
                });
        }

        /**
         * Create a modal from the view easily passing the title and the elemen
         */
        public launchSIMModal(title: string, sim: Models.ISIM): void {
            let copy: Models.SIM = sim === undefined ? Models.SIM.Empty() : Models.SIM.Copy(sim);
            this.modalService.showModal({
                templateUrl: Application.Controllers.SIMModalController.templateURL,
                controller: Application.Controllers.SIMModalController.$name,
                inputs: {
                    title: title,
                    sim: copy,
                    simPlans: this.simPlans,
                    newSim: sim === undefined ? true : false,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.SIMModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.scope.loadSelectize();
                modal.close.then((result: IModalResult) => {
                    modalElem.hide();
                    if (result) {
                        $('#saving-spinner').css({display: 'block'});
                        this.saveSIM(result, sim);
                    }
                });
            });
        }

        /**
         * Launch a modal when attempting to delete a sim from the list
         */
        public deleteSIMModal(sim: Models.ISIM): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE SIM',
                    description: "This action cannot be undone.",
                    name: sim.iccid,
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result) {
                        $('#saving-spinner').css({display: 'block'});
                        this.deleteSIMCard(sim);
                    }
                });
            });
        }

        private initData(): void {
            this.paginationPage = 0;
            this.paginationSize = -1;
            this.loadSimCards(0, 9999999, undefined);
        }

        private loadSimCards(page?: number, size?: number, sort?: string): void {
            $('#saving-spinner').css({display: 'block'});
            this.simPlanService
                .getAllSimPlansPromise()
                .then((simPlans: Models.SimPlan[]) => {
                    for (let i: number = 0; i < simPlans.length; i++) {
                        if (simPlans[i].name === SimsController.UNKNOWN_PLAN)
                            simPlans[i].dataAmount = SimsController.DEFAULT_DATA_PLAN;
                    }
                    this.simPlans = simPlans;
                    this.simService
                        .getAllPaginatedSimsAndDetails(page, size, sort, this.simPlans)
                        .then((sims: Models.IPaginatedList<Models.ISIM>) => {
                            this.simCards = sims;
                            this.totalSims = sims ? sims.elements.length : 0;
                            this.loadDashboardData();
                            $('#saving-spinner').css({display: 'none'});
                        });
                });
        }

        private loadDashboardData(): void {
            this.simService
                .getDashboardData()
                .then((dd: Models.ISIMDashboardData) => {
                    this.noPlanSims = dd.noPlanSims;
                    this.lowDataRemainingSims = dd.lowDataRemainingSims;
                    this.medDataRemainingSims = dd.medDataRemainingSims;
                    this.higDataRemainingSims = dd.higDataRemainingSims;
                    this.topSimPlans = dd.topSimPlans;
                    this.loadViewDashboard();
                });
        }

        private loadViewDashboard(): void {
            this.unassignedPercentage = this.totalSims === 0 ? 0 : (this.noPlanSims / this.totalSims) * 100;
            this.lowremPercentage = this.totalSims === 0 ? 0 : (this.lowDataRemainingSims / this.totalSims) * 100;
            this.medremPercentage = this.totalSims === 0 ? 0 : (this.medDataRemainingSims / this.totalSims) * 100;
            this.highremPercentage = this.totalSims === 0 ? 0 : (this.higDataRemainingSims / this.totalSims) * 100;
        }

        private loadSelectize(): void {
            if (this.selectize !== undefined)
                this.selectize.destroy();
            let $select: JQuery = $('#select-page-size').selectize({
                labelField: 'text',
                valueField: 'value',
                maxItems: 1,
                onChange: (paginationSize: number): void => {
                    let firstTime: boolean = this.paginationSize === -1;
                    this.paginationSize = paginationSize;
                    this.paginationPage = 0;
                    if (!firstTime) this.loadSimCards();
                },
                options: [
                    { value: 10, text: '10 sims per page'},
                    { value: 20, text: '20 sims per page'},
                    { value: 50, text: '50 sims per page'},
                    { value: 100, text: '100 sims per page'},
                ],
            });
            this.selectize = $select[0].selectize;
            this.selectize.setValue(10);
        }
    }
}
